/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Backdrop, Divider, Card, CardHeader, CardContent, CardActions, Paper, Tooltip, Typography, Avatar, IconButton, 
    FormControlLabel, Switch, Collapse, TextField, Popover } from '@material-ui/core'


import { AddAlarm, ArrowRightAlt, Edit, PauseCircleFilled, PlayCircleFilled, AccessTime, Visibility, Delete, Clear, ExpandLess, ExpandMore } from '@material-ui/icons'

import cronstrue from 'cronstrue';

import CronEditor from './CronEditor'
import SecureWrapper from '../Security/SecureWrapper';

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      // primary: {
      //     main: "#FF6600",
      //     contrastText: "#FFFFFFFF"
      // },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({
    backdrop : {
        zIndex: theme.zIndex.drawer + 1,
    }
})

class Scheduler extends Component {
    state = {
        job_name: "",
        group_name: null,
        last_fired_time: null,
        next_fire_time: null,
        job_status: "",
        start_time: null,
        end_time: null,
        cron_expression: "0 0 0 ? * * *",
        recursive : false,
        editor : false,
        delete_open : false,
        name_error : null,
        start_date_error : null,
        end_date_error : null,
        open_summary : false
    }

    componentWillMount () {
        if (this.props.scheduleJob !== null) {
            let recursive = false
            let cron_expression = "0 0 0 ? * * *"
            if (this.props.scheduleJob.cron_expression !== null) {
                recursive = true
                cron_expression = this.props.scheduleJob.cron_expression
            }
            this.setState({
                ...this.state,
                ...this.props.scheduleJob,
                recursive : recursive,
                cron_expression : cron_expression
            }, () => console.log("Scheduler State : ", this.state))
        }
    }

    componentWillUpdate (nextProps) {
        if (this.props.scheduleJob !== null) {
            if (JSON.stringify(this.props.scheduleJob) !== JSON.stringify(nextProps.scheduleJob)) {
                this.setState({
                    ...this.state,
                    ...this.props.scheduleJob
                }, () => console.log("Scheduler Updated State: ", this.state))
            }
        }
    }

    delete = React.createRef()

    convertToISOString = (date_string) => {
        let date = new Date(date_string)
        var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            var norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        };

        return date.getFullYear() +
                '-' + pad(date.getMonth() + 1) +
                '-' + pad(date.getDate()) +
                'T' + pad(date.getHours()) +
                ':' + pad(date.getMinutes()) +
                ':' + pad(date.getSeconds()) +
                dif + pad(tzo / 60) +
                ':' + pad(tzo % 60);
    }

    getCronMessage = () => {
        if (this.state.cron_expression !== null) {
            return (
                <div style = {{dispaly : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center', width : '100%'}}>
                    {this.state.cron_expression ? <Typography display = 'block' variant = 'caption'>{"Fires " + cronstrue.toString(this.state.cron_expression)}</Typography> : null}
                </div>
            )
        }
    }

    renderMessage = () => {
        if (this.props.schedule) {
            return (
                <div style = {{
                    height : '100%',
                    padding : '10px',
                    borderLeft : '1px solid rgba(0,0,0,0.12)'
                }}>
                    <Typography style = {{color : "#2296f3"}} variant = 'caption'>{this.state.job_name}</Typography>
                    <Divider/>
                    {this.getCronMessage()}
                </div>
            )
        }
    }

    renderActions = () => {
        return (
            <div style = {{display : 'flex', flexDirection : 'row'}}>
                {this.renderView()}
                {this.renderPauseResume()}
                {this.renderDelete()}
            </div>
        )
    }

    renderView = () => {
        return (
            <Tooltip title = "View Schedule">
                <IconButton size = 'small' color = 'primary' onClick = {() => this.updateState('editor', true)}>
                    <Visibility fontSize = 'small'/>
                </IconButton>
            </Tooltip>
        )
    }

    renderDelete = () => {
        return (
            <Fragment>
                <Tooltip title = "Delete Schedule">
                    <IconButton ref = {this.delete} size = 'small' color = 'secondary' onClick = {() => this.updateState('delete_open', !this.state.delete_open)}>
                        <Delete fontSize = 'small'/>
                    </IconButton>
                </Tooltip>
                <Popover
                    open={this.state.delete_open}
                    anchorEl={this.delete.current}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <div style = {{
                        padding : '10px',
                        backgroundColor : '#F0F0F0',
                    }}>
                        <div style = {{width : '100%'}}>
                            <Typography variant = 'body2' align = 'center'>Deleting {this.state.job_name}</Typography>
                        </div>
                        <div style = {{width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'flex-end'}}>
                            <Tooltip title = "Cancel">
                                <IconButton color = 'primary' onClick = {() => this.updateState('delete_open', !this.state.delete_open)}>
                                    <Clear fontSize = 'small'/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title = "Delete">
                                <IconButton color = 'secondary' onClick = {() => {
                                    this.setState({
                                        ...this.state,
                                        delete_open : !this.state.delete_open
                                    }, () => this.props.delete(this.state.job_name))
                                }}>
                                    <Delete fontSize = 'small'/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                </Popover>
            </Fragment>
        )
    }

    renderCollapse = () => {
        if (!this.state.open_summary) {
            return (
                <Tooltip title = "View Summary">
                    <IconButton size = 'small' onClick = {() => this.updateState('open_summary', true)}>
                        <ExpandMore fontSize = 'small'/>
                    </IconButton>
                </Tooltip>
            )
        } else {
            return (
                <Tooltip title = "Collapse Summary">
                    <IconButton size = 'small' onClick = {() => this.updateState('open_summary', false)}>
                        <ExpandLess fontSize = 'small'/>
                    </IconButton>
                </Tooltip>
            )
        }
    }

    renderPauseResume = () => {
        if (this.state.job_status === "Paused") {
            return (
                <Tooltip title = "Resume Schedule">
                    <IconButton size = 'small' color = 'primary' onClick = {() => this.props.resume(this.state.job_name)}>
                        <PlayCircleFilled fontSize = 'small'/>
                    </IconButton>
                </Tooltip>
            )
        } else {
            return (
                <Tooltip title = "Pause Schedule">
                    <IconButton size = 'small' color = 'primary' onClick = {() => this.props.pause(this.state.job_name)}>
                        <PauseCircleFilled fontSize = 'small'/>
                    </IconButton>
                </Tooltip>
            )
        }
    }

    renderSchedule = () => {
        if (this.props.scheduleJob !== null) {
            return (
                <Paper style = {{
                    backgroundColor : this.state.job_status === "Scheduled" ? "#FFFFFF" : "#F0F0F0",
                    boxSizing : 'border-box',
                    width : '100%'
                }}
                variant = {this.state.job_status === "Scheduled" ? "elevation" : "outlined"}
                >
                    <div
                        style = {{padding : '5px', width : '100%'}}
                    >
                        <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            {this.renderPauseResume()}
                            <div style = {{flexGrow : 1}}>
                                <Typography style = {{ display : 'block', maxWidth : '150px'}} noWrap color = {this.state.job_status === "Scheduled" ? 'primary' : 'textSecondary'} variant = 'caption'>{this.state.job_name}</Typography>
                            </div>
                            <div>
                                {this.renderView()}
                                {this.renderDelete()}
                                {this.renderCollapse()}
                            </div>
                        </div>
                        <Collapse in = {this.state.open_summary}>
                            <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                            <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'space-between'}}>
                                {isNaN(Date.parse(this.state.start_time)) ? null : <Typography variant = 'caption'>{new Date(this.state.start_time).toLocaleString()}</Typography>}
                                <ArrowRightAlt fontSize = 'small' style = {{margin : '3px', color : "#2296f3"}} />
                                {isNaN(Date.parse(this.state.end_time)) ? <Typography align = 'right' variant = 'caption'>{this.state.end_time === null ? "Indefinite" : null }</Typography>
                                : <Typography align = 'right' variant = 'caption'>{new Date(this.state.end_time).toLocaleString()}</Typography>}
                            </div>
                            {this.getCronMessage()}
                        </Collapse>
                    </div>
                </Paper>
            )
        } else {
            return (
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/schedule",
                        method : "POST",
                        operands : []
                      }}
                    >
                <Tooltip title = "Add Schedule">
                    <IconButton aria-label = "add or edit schedule" size = 'small' onClick = {() => this.updateState('editor', !this.state.editor)}>
                        <AddAlarm style = {{color : "#2296f3"}} fontSize = 'small'/>
                    </IconButton>
                </Tooltip>
                </SecureWrapper>
            )
        }
    }

    renderCronEditor = () => {
        if (this.state.editor === true) {
            return (
                <CronEditor 
                    schedule = {this.state} 
                    editor = {this.state.editor} 
                    updateState = {(key, value) => this.updateState(key, value)}
                    disabled = {this.state.job_status === "Scheduled" ? true : false}
                    name_error = {this.state.name_error}
                    start_date_error = {this.state.start_date_error}
                    end_date_error = {this.state.end_date_error}
                    submitSchedule = {this.submitSchedule}
                />
            )
        }
    }

    submitSchedule = () => {
        let start_time_error = null
        let end_time_error = null
        let name_error = null
        if (this.state.start_time === null) {
            start_time_error = "Start Date Time cannot be empty"
        }

        if (this.state.job_name === "") {
            name_error = "Job Name cannot be empty"
        }

        if (start_time_error === null && end_time_error === null && name_error === null) {
            let schedule_object = {
                job_name : this.state.job_name,
                group_name : this.props.group_name,
                start_time : this.state.start_time,
                end_time : this.state.end_time !== null ? this.state.end_time : null
            }

            if (this.state.recursive) {
                schedule_object.cron_expression = this.state.cron_expression
            } else {
                schedule_object.cron_expression = null
            }

            this.setState({
                ...this.state,
                editor : false,
                start_date_error : null,
                name_error : null
            }, () => this.props.submit_schedule(schedule_object))
        } else {
            this.setState({
                ...this.state,
                start_date_error : start_time_error,
                name_error : name_error
            })
        }
    }

    updateState = (key, value) => {
        this.setState({
            [key] : value
        }, () => console.log("Key : " + key + " - Value : " + value))
    }

    render() {
        const { classes } = this.props
        return (
            <Fragment>
                <ThemeProvider theme = {blue_theme}>
                    <div style = {{
                        boxSizing : 'border-box',
                        width : '100%',
                        maxWidth : '100%',
                        margin : '5px',
                        display : 'flex',
                        flexDirection : 'row',
                        justifyContent : 'center',
                        alignItems : 'center'
                    }}>
                        {this.renderSchedule()}
                    </div>
                    {this.renderCronEditor()}
                </ThemeProvider>
            </Fragment>
        );
    }
}

export default withStyles(styles)(Scheduler);